/**
 * Generated by orval 🍺
 * Do not edit manually.
 * OnEarly Core API
 * OnEarly Core HTTP API
 * OpenAPI spec version: 0.0.1
 */
import * as zod from 'zod';

export const createChatInvitationBodyIdentifierMin = 3;
export const createChatInvitationBodyIdentifierMax = 320;

export const CreateChatInvitationBody = zod.object({
  historyIntent: zod
    .enum(['all', 'now'])
    .optional()
    .describe("How much thread history the claimant receives. Default 'all'."),
  identifier: zod
    .string()
    .min(createChatInvitationBodyIdentifierMin)
    .max(createChatInvitationBodyIdentifierMax)
    .optional()
    .describe(
      'Exact email or phone the caller already holds. Normalized server-side (lowercased email \/ E.164 phone).',
    ),
  targetActorUuid: zod
    .uuid()
    .optional()
    .describe(
      'An OE USER actor to invite (account exists, has never opened chat). Gated by the same visibility arms as identity resolution.',
    ),
});

export type CreateChatInvitationBody = zod.input<typeof CreateChatInvitationBody>;
export type CreateChatInvitationBodyOutput = zod.output<typeof CreateChatInvitationBody>;
